import { ref, computed, isReactive } from 'vue';
import { defineStore, storeToRefs } from 'pinia'
import api from '@/libs/axios';
import { ApiError, type ApiResponse } from '@/libs/axios';
import type { Postech, Project } from '@/types/types'
import { useProjectStore, useAlertStore, useCacheStore } from '@/stores'
import { closeoutSchema, postechPileSchema, customerSchema } from '@/types/types'
import * as yup from 'yup'
import { useCloseoutBuilder } from '@/composables/Closeout-builder'
//import { useStoreSyncer } from '@/composables/Store-syncer';
import { sumField } from '@/libs/utils'
import router from '@/router'


const existingPostechSchema = yup.object({
  installer_id: yup.number().required(),
  pilesSupporting: yup.string().required(),
  pileLoads: yup.mixed().oneOf(['Loads Calculated', 'Loads Provided by Others']),
  piles: yup.array().of(postechPileSchema).defined().min(1)
})

const newPostechSchema = yup.object({
  created_by: yup.string().defined(), // string
  projectId: yup.number().required(),
  installer_id: yup.number().required(),
  pilesSupporting: yup.string().required(),
  pileLoads: yup.mixed().oneOf(['Loads Calculated', 'Loads Provided by Others']).required(),
  piles: yup.array().of(postechPileSchema).defined().min(1)
})

//for closeout, piles fields are required:
const postechCloseoutPileSchema = yup.object({
  pileType: yup.string().defined(),
  torqueMin: yup
    .number()
    .min(0)
    .integer()
    .transform((curr, orig) => (orig === '' ? null : curr)),
  torqueMax: yup
    .number()
    .min(0)
    .integer()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr)),
  pileCount: yup.number().positive().integer().defined()
})

const postechCloseoutSchema = yup.object({
  id: yup.number(),
  projectId: yup.number().defined(),
  installer: customerSchema.required(),
  pilesSupporting: yup.string().required(),
  pileLoads: yup.mixed().oneOf(['Loads Calculated', 'Loads Provided by Others']),
  piles: yup.array().of(postechCloseoutPileSchema).defined().min(1)
})
/**
 * All cached postechs are stored within the projects cache
 */
export const usePostechStore = defineStore('postechs', () => {
  const cache = useCacheStore();
  //const { fetchAll, update, remove, create, allItems, loading, error } = useStoreSyncer('/postech', 'postech');
  const alert = useAlertStore(); 
  const loading = ref(false);
  const error = ref(null);


  const allPostech = computed(()=>{
  const allProjects = cache.getFromCache('projects') || [];
  return allProjects.map(proj =>{
    return proj.postechs
  }).flat();
  // return cache.getFromCache('postech') || [];
   //return allItems.value;
  })

  const tableData = computed(()=>{
    const data = allPostech.value;
   // const data = allItems.value;

    console.log(".. parseTableData for Postech...");
    //map array to show customer fields
   //const mapped = Promise.all(data.map(async (postech) => {
    const mapped = data.map(postech =>{
    //inv.customerName = inv.customer.invoiceName;
    //console.log('... piles = ' + JSON.stringify(postech.piles))
    const temp = JSON.parse(JSON.stringify(postech));
    try{
      const totalPiles = sumField(postech.piles, 'pileCount')
      temp.pileCount = totalPiles
    }catch(error){
      console.error("..trapped error on totalPiles parseTable = " + error);
      console.log("..postech = " + postech.id);
    }
    //const totalPiles = 99;
    let installer;
    try{
     installer = postech.installer.invoiceName;
     //console.log(".....installer.invoiceName = " + installer);
     temp.installer = installer;
    }catch(error){
      console.error("..trapped error Postech-table.setPostechs() error fetching postech on installer: " + error);
      console.error("...postech obj = " + JSON.stringify(postech));
      temp.installer = "undefined in backend";
    }
    return temp
  })

  return mapped;
  })
 

  async function getById(id: number) {
    console.log('postech store getting by id ' + id)
    try{
      return allPostech.value.find(postech =>{
        return postech.id === id;
      });
    }catch (error){
      console.log("error on postechstore.getById : " + error);
    }
  }

  /**
   * get all postech objects for project
   */
  async function getProjectPostechs(projectId: number) {
    console.log('postech store getProjectPostechs ' + projectId)
    loading.value = true;
    const projects = useProjectStore();
    const { allProjects } = storeToRefs(projects);
    //const allProjects = await projects.getAll();

    const postechArr = allProjects.filter(proj =>{
      proj.id === projectId;
    }).map(proj =>{
      return proj.postechs;
    })
    loading.value = false;
    return postechArr;

  }

  /**
   * update a single postech
   * @return
   */
  async function updatePostech(postech: Postech) {
    console.log('postech store.updatePostech()...')
    const projects = useProjectStore();
    loading.value = true;

    try{
      const parsed = await existingPostechSchema.validate(postech, { stripUnknown: true })
      const resp : ApiResponse<Postech> = await api.put(`/postech/${postech.id}`, parsed);
      const updated : Postech = resp.data.data['postech'];    //TODO ensure API returns all graphFetched relations
      const projBefore : Project = projects.getById(updated.projectId);
      const postechArrAfter = projBefore.postechs.map(postech =>{
        return postech.id === updated.id ? updated : postech;
      })
      projBefore.postechs = postechArrAfter;
      await projects.writeChanges(projBefore);

      alert.success(`updated Postech ${updated.id} succesful`);

      await new Promise(resolve => setTimeout(()=>{
        alert.clear()
          loading.value = false;
          return updated;
      }, 3000));
        
        
    }catch(err){
        console.log("error in postech-store.updatePostech()..")
          error.value = err.toString();
        if(err.name == 'ValidationError'){
          console.log('validation error : ' + err)
          alert.error('validation error : ' + err)
          setTimeout(() => {
              alert.clear()
              loading.value = false;
          }, 3000)
        }else if(err instanceof ApiError){
          console.log("put to /postech trapped APIerror" + err.message);
          alert.error("put to /postech trapped APIerror" + err.message);
        }else{
          console.log("error with updating postech object : " + err);
          alert.error("error with updating postech object : " + err);
        }
        loading.value = false;
        if(err instanceof ApiError){
            alert.error(err.message)
        }else{
            alert.error("error with updating postech.." + err);
        }
    }
                
           
  }

  /**
   * delete a Postech
   */
  async function deletePostech(id: Number) {
    console.log('postech store deletePostech for id : ' + id)
    const projects = useProjectStore();
    //return await remove(id);
    loading.value = true;
    let resp : ApiResponse<Object>;
    try{
      resp = await api.delete(`/postech/${id}`);
      const deleted : Postech = resp.data.data['deleted'];
      //console.log("..deleted postech = " + JSON.stringify(deleted));
      const projBefore : Project = projects.getById(deleted.projectId);
      //console.log("... deleted.id = " + deleted.id);
      const postechArr = projBefore.postechs.filter(postech=>{
          console.log("...proj postech.id = " + postech.id)
          return postech.id != deleted.id;
      });
      projBefore.postechs = postechArr;
      //console.log("...postechArr after filter = " + JSON.stringify(postechArr));
      projects.writeChanges(projBefore);

    }catch(err){
      console.log("..error in postech-store.deletePostech()...");
      if(err instanceof ApiError){
          console.log(".delete trapped APIerror" + err.message);
          throw err;
      }else{
          console.log("error with deleting postech object : " + err);
          alert.error("error with deleting postech object : " + err);
      }
    }
  }

  /**
   * create a new Postech entr
   * backend will assign the postechId and return it
   */
  async function createPostech(postech: Postech) {
    console.log('postech store createPostech : ' + JSON.stringify(postech))
    const projects = useProjectStore();
    postech.installer_id = postech.installer.id
    loading.value = true;

    try{
      const parsed = await newPostechSchema.validate(postech, { stripUnknown: true })
      const resp : ApiResponse<Postech> = await api.post(`/postech/`, parsed);
      const created : Postech = resp.data.data['postech'];
      //console.log("..added postech = " + JSON.stringify(created));
      const projBefore : Project = projects.getById(created.projectId);
      projBefore.postechs.push(created);
      //console.log("... created.id = " + created.id);
      await projects.writeChanges(projBefore);
      await new Promise(resolve => setTimeout(()=>{
        alert.clear()
        loading.value = false;
        router.push(`/projects/${created.projectId}/postech/${created.id}`);
      }, 3000));

    }catch(err){
      console.log("..error in postech-store.createPostech()...");
      error.value = err.toString();
      if(err.name == 'ValidationError'){
        console.log('validation error : ' + err)
        alert.error('validation error : ' + err)
        setTimeout(() => {
            alert.clear()
            loading.value = false;
        }, 3000)
      }else if(err instanceof ApiError){
          console.log("post to /postech trapped APIerror" + err.message);
          alert.error("post to /postech trapped APIerror" + err.message);
      }else{
          console.log("error with creating postech object : " + err);
          alert.error("error with creating postech object : " + err);
      }

    }
  }



  /**
   * create closeout through axios backend
   * TOD0 validate the postech object first with yup
   */
  async function createCloseout(postech: Postech) {
    console.log('Postech store createCloseout()...')
    console.log('validating object : ' + JSON.stringify(postech))
    //const alert = useAlertStore()
    alert.loading('..creating closeout...');

    const projects = useProjectStore()
    //const project = projects.currentProject
    const project = await projects.getById(postech.projectId);
    
    let parsedOne;
    try {
      parsedOne = await postechCloseoutSchema.validate(postech, { stripUnknown: true }) //remove extra fields
      //console.log('parsedOne = ' + JSON.stringify(parsedOne))
    } catch (err) {
      //err.name; // => 'ValidationError'
      //err.errors; // => ['Deve ser maior que 18']
      console.log(err)
      alert.error(err)
      setTimeout(() => {
        alert.clear()
      }, 3000)
      return
    }
    let closeout;
    if(parsedOne){
      const closeoutBuilder = useCloseoutBuilder()
      closeout = await closeoutBuilder.buildPostechCloseout(project, parsedOne)
     /*console.log('-------closeout returned:--------')
      Object.keys(closeout).forEach((key) => {
        console.log('key ' + key, 'value = ', closeout[key])
      })*/
    }
   
    //try form validation
    
    let parsed
    try {
      parsed = await closeoutSchema.validate(closeout, { stripUnknown: true }) //remove extra fields
      console.log('parsed = ' + JSON.stringify(parsed))
    } catch (err) {
      //err.name; // => 'ValidationError'
      //err.errors; // => ['Deve ser maior que 18']
      console.log(err)
      alert.error(err)
      setTimeout(() => {
        alert.clear()
      }, 3000)
      return
    }
    //if form is valid:
    if (parsed) {
      //let response = null;
      await api
        .post('/gdrive/createCloseout', parsed)
        .then((res) => {
          alert.success(res.data.message)
          projects.addStatus(project, 'CLOSEOUT');
          setTimeout(() => {
            alert.clear()
            // router.back();
          }, 3000)
        })
        .catch((error) => {
          if (error.response) {
            alert.error(error.response.data)
          } else if (error.request) {
            alert.error(error.request)
          }
        })
    }
  }
  return {
    allPostech,
    //fetchAllPostech,
    getById,
    //getAllPileTypes, moved to piles store
    getProjectPostechs,
    updatePostech,
    deletePostech,
    createPostech,
    createCloseout,
    loading,
    tableData
  }
})


 
